import React, { PropTypes } from 'react'
import { Relayout, RelayoutItem } from 'relayout'
import CSSModules from 'react-css-modules'

import PrimaryButtonResponsive from 'components/primary-button-responsive'

import styles from './attendee-header.css'

const AttendeeHeader = ({ hasAttendees, onDownload, onPrint }) => (
  <div styleName="attendee-header">
    <Relayout valign="middle">
      <RelayoutItem sm="5" md="4" lg="6">
        <div styleName="title">Attendee List</div>
      </RelayoutItem>
      <RelayoutItem sm="7" md="8" lg="6" styleName="actions">
        <div styleName="download">
          <PrimaryButtonResponsive disabled={!hasAttendees} label="Download" onClick={onDownload} />
        </div>
        <PrimaryButtonResponsive disabled={!hasAttendees} label="Print" onClick={onPrint} />
      </RelayoutItem>
      <RelayoutItem>
        <p styleName="text">
          These contact details (email / phone numbers) are for operational purposes only.  Customers have not
          consented to marketing use. Under the Data Protection Act, such use is prohibited. Any costs associated with
          their misuse (including all legal fees and any damages) will be the responsibility of the Partner.
        </p>
      </RelayoutItem>
    </Relayout>
  </div>
)

AttendeeHeader.propTypes = {
  hasAttendees: PropTypes.bool,
  onDownload: PropTypes.func,
  onPrint: PropTypes.func,
}

export default CSSModules(AttendeeHeader, styles, { allowMultiple: true })



/** WEBPACK FOOTER **
 ** ./src/components/attendee-header/attendee-header.js
 **/